import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from './Home';
import Timeline from './Timeline';
import Gallery from './Gallery';
import Music from './Music';
import LoveLetter from './LoveLetter';
import TicTacToe from './Games';


function App() {
  return (
    <Router>
      <nav style={{ textAlign: 'center', padding: '10px', background: '#ffe6e6' }}>
        <Link to="/" style={{ margin: '0 10px', textDecoration: 'none', color: '#ff4d4d' }}>Home</Link>
        <Link to="/timeline" style={{ margin: '0 10px', textDecoration: 'none', color: '#ff4d4d' }}>Timeline</Link>
        <Link to="/gallery" style={{ margin: '0 10px', textDecoration: 'none', color: '#ff4d4d' }}>Gallery</Link>
        <Link to="/loveletter" style={{ margin: '0 10px', textDecoration: 'none', color: '#ff4d4d' }}>Love Letter</Link>
        <Link to="/music" style={{ margin: '0 10px', textDecoration: 'none', color: '#ff4d4d' }}>Music</Link>
        <Link to="/games" style={{ margin: '0 10px', textDecoration: 'none', color: '#ff4d4d' }}>Games</Link>
      </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/timeline" element={<Timeline />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/loveletter" element={<LoveLetter />} />
        <Route path="/music" element={<Music />} />
        <Route path="/games" element={<TicTacToe />} />
      </Routes>
    </Router>
  );
}

export default App;
